import React from 'react'

import {useLocale} from '@/providers/locale'

type FormatDate = (date: string, options?: Intl.DateTimeFormatOptions) => string

export const useDateFormatter = () => {
    const currentLocale = useLocale()
    const [formatDate, setFormatDate] = React.useState<FormatDate>(() => () => '')

    React.useEffect(() => {
        const formatdDate: FormatDate = (date, options) => {
            return new Intl.DateTimeFormat(currentLocale.code, {
                day: '2-digit',
                month: 'long',
                year: 'numeric',
                ...options,
            }).format(new Date(date))
        }

        setFormatDate(() => formatdDate)
    }, [currentLocale])

    return formatDate
}
